export default {
  title: 'Referral Management',
  tab: 'REFERRAL',
  menu: {
    referralStatus: 'Referral Management',
    companyReferrers: 'Company Referrers',
    pointsRecord: 'Points Record'
  },
  leaderboard: {
    title: 'Company Referral Leaderboard',
    filter: {
      allCompanies: 'All Companies',
      company: 'Company Name',
      referrerType: 'Referrer Type',
      startTime: 'Start time',
      endTime: 'End time',
      tip: 'Referral data is calculated daily and updated before 9AM the following day.',
      keyword: 'Keywords Search'
    },
    referrerType: {
      all: 'All Referrers',
      employee: 'Employee Referrers',
      nonEmployee: 'Non-Employee Referrers'
    },
    column: {
      referrer: 'Referrer',
      employeeStatus: 'Employee Status',
      company: 'Employee Company',
      employeeId: 'Employee ID',
      email: 'Email',
      views: 'Views',
      submits: 'CV Submissions',
      applied: 'Applications',
      interviewed: 'Interviews',
      onboard: 'Onboarded',
      probation: 'Passed Probation',
      cash: 'Cash',
      points: 'Points',
      all: 'All'
    }
  }
}
